module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/apple-icon-57x57-7250c605f43b7c8a5ac826e6e64ebaff.png";